// Categories & cities are also returned by /api/meta/categories — kept here as fallback for UI hints.
export const FALLBACK_CATEGORIES = [
  { id: "chanteur", label: "Chanteur / Chanteuse" },
  { id: "dj", label: "DJ" },
  { id: "danseur", label: "Danseur / Danseuse" },
  { id: "humoriste", label: "Humoriste" },
  { id: "groupe_traditionnel", label: "Groupe Traditionnel" },
  { id: "musicien", label: "Musicien / Instrumentiste" },
  { id: "animateur", label: "Animateur / MC" },
  { id: "rappeur", label: "Rappeur / Slameur" },
  { id: "influenceur", label: "Influenceur" },
  { id: "comedien", label: "Comédien / Acteur" },
  { id: "photographe", label: "Photographe / Vidéaste" },
  { id: "beatmaker", label: "Beatmaker / Producteur" },
];

export const FALLBACK_CITIES = [
  "Conakry", "Kindia", "Kankan", "Labé", "Mamou",
  "Faranah", "N'Zérékoré", "Boké", "Siguiri", "Kissidougou",
];

export const UNLOCK_FEE_GNF = 53000;
export const COMMISSION_PERCENT = 10;

export function formatGNF(n) {
  if (n == null || isNaN(n)) return "—";
  return new Intl.NumberFormat("fr-FR").format(Number(n)) + " GNF";
}

export function statusLabel(s) {
  return ({
    pending: "En attente",
    accepted: "Acceptée",
    declined: "Refusée",
    open: "Ouvert",
    in_progress: "En cours",
    validated: "Validé",
    closed: "Clôturé",
    cancelled: "Annulé",
    commission_paid: "Commission payée",
  })[s] || s;
}

export function statusColor(s) {
  return ({
    pending: "bg-[hsl(var(--secondary))] text-foreground",
    accepted: "bg-[hsl(var(--accent))] text-white",
    declined: "bg-destructive text-white",
    open: "bg-muted text-foreground",
    in_progress: "bg-[hsl(var(--secondary))] text-foreground",
    validated: "bg-[hsl(var(--accent))] text-white",
    closed: "bg-foreground text-white",
    cancelled: "bg-muted text-muted-foreground",
  })[s] || "bg-muted text-foreground";
}
